import { useEffect, useState } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'

const CATEGORY_ORDER = { general: 0, shops: 1, socials: 2 }

function isEnabled(link) {
  return link.enabled !== false
}

/** Footer «Dove acquistare»: flag site o placement legacy header/both */
function isSiteLink(link) {
  if (link.site === true) return true
  const placement = link.placement
  return placement === 'header' || placement === 'both'
}

export function usePublicLinks({ site } = {}) {
  const [links, setLinks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    async function load() {
      setLoading(true)
      setError(null)
      try {
        const snapshot = await getDocs(collection(db, 'public_links'))
        if (cancelled) return

        let items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))

        items = items.filter(isEnabled)
        if (site) {
          items = items.filter(isSiteLink)
        }

        items.sort((a, b) => {
          if (site) {
            return (a.sort_order ?? 0) - (b.sort_order ?? 0)
          }
          const catA = CATEGORY_ORDER[a.category ?? 'general'] ?? 0
          const catB = CATEGORY_ORDER[b.category ?? 'general'] ?? 0
          if (catA !== catB) return catA - catB
          return (a.sort_order ?? 0) - (b.sort_order ?? 0)
        })
        setLinks(items)
      } catch (err) {
        console.error('usePublicLinks:', err)
        if (!cancelled) setError(err)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [site])

  return { links, loading, error }
}
